import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const ProdottiEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		nome_prodotto: yup.string().required().label("Nome Prodotto"),
		descrizione: yup.string().nullable().label("Descrizione"),
		id_categoria: yup.string().required().label("Id Categoria"),
		scheda_prodotto: yup.string().nullable().label("Scheda Prodotto"),
		foto_copertina: yup.string().nullable().label("Foto Copertina"),
		visibile_in_home: yup.string().nullable().label("Visibile In Home")
	});
	// form default values
	const formDefaultValues = {
		nome_prodotto: '', 
		descrizione: '', 
		id_categoria: '', 
		scheda_prodotto: '', 
		foto_copertina: '', 
		visibile_in_home: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/prodotti`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="ProdottiEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="modificare"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Nome Prodotto *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nome_prodotto"  onChange={formik.handleChange}  value={formik.values.nome_prodotto}   label="Nome Prodotto" type="text" placeholder="accedere Nome Prodotto"        className={inputClassName(formik?.errors?.nome_prodotto)} />
                                                <ErrorMessage name="nome_prodotto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Descrizione 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="descrizione"  onChange={formik.handleChange}  value={formik.values.descrizione}   label="Descrizione" type="text" placeholder="accedere Descrizione"        className={inputClassName(formik?.errors?.descrizione)} />
                                                <ErrorMessage name="descrizione" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Id Categoria *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/id_categoria_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="id_categoria"     optionLabel="label" optionValue="value" value={formik.values.id_categoria} onChange={formik.handleChange} options={response} label="Id Categoria"  placeholder="Seleziona un valore ..."  className={inputClassName(formik?.errors?.id_categoria)}   />
                                                    <ErrorMessage name="id_categoria" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Scheda Prodotto 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.scheda_prodotto)}>
                                                    <Uploader name="scheda_prodotto" showUploadedFiles value={formik.values.scheda_prodotto} uploadPath="fileuploader/upload/scheda_prodotto" onChange={(paths) => formik.setFieldValue('scheda_prodotto', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Scegli i file o trascina i file qui" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="scheda_prodotto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Foto Copertina 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.foto_copertina)}>
                                                    <Uploader name="foto_copertina" showUploadedFiles value={formik.values.foto_copertina} uploadPath="fileuploader/upload/foto_copertina" onChange={(paths) => formik.setFieldValue('foto_copertina', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Scegli i file o trascina i file qui" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="foto_copertina" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Visibile In Home 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="visibile_in_home"     optionLabel="label" optionValue="value" value={formik.values.visibile_in_home} onChange={formik.handleChange} options={app.menus.inEvidenza} label="Visibile In Home"  placeholder="Seleziona un valore ..."  className={inputClassName(formik?.errors?.visibile_in_home)}   />
                                                <ErrorMessage name="visibile_in_home" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Aggiornare" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
ProdottiEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'prodotti',
	apiPath: 'prodotti/edit',
	routeName: 'prodottiedit',
	submitButtonLabel: "Aggiornare",
	formValidationError: "Il modulo non è valido",
	formValidationMsg: "Si prega di compilare il modulo",
	msgTitle: "Aggiorna registro",
	msgAfterSave: "Registra aggiornato correttamente",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ProdottiEditPage;
